import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import BaseMatManModal from '@monorepo/shared/src/components/common/Modals/BaseMatManModal';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

const tAssignment = (key, options?) => translate('assignment', key, options);

type SaveAssignmentModalProps = {
  closeModal: () => void;
  handleEditSave: () => void | Promise<void>;
  headerText: string;
  isUnassigningLetter: boolean;
  rightButtonClass: string;
  rightButtonText: string;
};

const SaveAssignmentModal: React.FC<SaveAssignmentModalProps> = ({
  closeModal,
  handleEditSave,
  headerText,
  isUnassigningLetter,
  rightButtonClass,
  rightButtonText,
}) => {
  const [isSaving, setIsSaving] = useState(false);

  const saveChanges = async () => {
    setIsSaving(true);
    try {
      await handleEditSave();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <BaseMatManModal
      leftButtonAction={closeModal}
      rightButtonAction={saveChanges}
      headerText={headerText}
      headerFontSize={'24px'}
      leftButtonText={tAssignment('backToEditing')}
      rightButtonText={rightButtonText}
      rightButtonClass={isUnassigningLetter ? rightButtonClass : ''}
      rightButtonProps={{ disabled: isSaving }}
    >
      <Box>
        <Typography variant="subtitle1">{tAssignment('saveChangesBody1')}</Typography>
        <Typography variant="subtitle1">{tAssignment('saveChangesBody2Edit')}</Typography>
      </Box>
    </BaseMatManModal>
  );
};

export default SaveAssignmentModal;
